import _get from 'lodash/get'
import { renew } from 'services/auth'
import { setAuthPersistentData } from 'services/auth/actions'
import {
  approveRemoteLoginCode,
  consumeRemoteLoginCode,
} from './index'

export const SET_REMOTE_LOGIN_CODE_PROCESSING = 'SET_REMOTE_LOGIN_CODE_PROCESSING'
export const SET_REMOTE_LOGIN_CODE_DATA = 'SET_REMOTE_LOGIN_CODE_DATA'

export function getRemoteLoginCodeApproval ({ auth, remoteLoginCode }) {
  return async function getRemoteLoginCodeApprovalThunk (dispatch) {
    dispatch(setRemoteLoginCodeProcessing(true))
    const data = await approveRemoteLoginCode({ auth, remoteLoginCode })
    dispatch(setRemoteLoginCodeData(data))
    return data
  }
}

export function setRemoteLoginCodeProcessing (value) {
  return {
    type: SET_REMOTE_LOGIN_CODE_PROCESSING,
    payload: value,
  }
}

export function setRemoteLoginCodeData (data, processing = false) {
  return {
    type: SET_REMOTE_LOGIN_CODE_DATA,
    payload: { data, processing },
  }
}

export function doConsumeRemoteLoginCode ({ remoteLoginCode }) {
  return async function doConsumeRemoteLoginCodeThunk (dispatch) {
    try {
      dispatch(setRemoteLoginCodeProcessing(true))
      const { jwt } = await consumeRemoteLoginCode({ remoteLoginCode })
      // Renew auth data with a jwt obtained from remote login code response
      const data = await renew({ auth: { jwt }, logoutAllDevices: false })
      const success = _get(data, 'auth.success')
      if (success) {
        dispatch(setAuthPersistentData(data.auth))
      }
      return { success }
    } catch (e) {
      return { success: false }
    }
  }
}
